import { render, staticRenderFns } from "./modal-help.vue?vue&type=template&id=0bcb265b"
import script from "./modal-help.vue?vue&type=script&lang=js"
export * from "./modal-help.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports